export default "__VITE_ASSET__CtFNe1gX__"